import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { CartProvider } from "./components/shop/cart/CartProvider";
import { UserProvider } from "./components/User/UserContext";
import { BrowserRouter } from "react-router-dom";
import { Auth0ProviderWithNavigate } from "./components/auth0/Auth0ProviderWithNavigate";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<UserProvider>
			<BrowserRouter>
				<Auth0ProviderWithNavigate>
					<CartProvider>
						<App />
					</CartProvider>
				</Auth0ProviderWithNavigate>
			</BrowserRouter>
		</UserProvider>
	</React.StrictMode>
);
